import { useEffect } from 'react';
import Link from 'src/components/primitives/Link/Link';
import useAlertNotify from 'src/components/Toasts/AlertNotifications/hooks/useAlertNotify';
import useCurrentAuthority from 'src/hooks/useCurrentAuthority';

const TOP_MAKER_AUTHORITIES = [
	'CksYhws4jNNzs8jszgjhuNvAqRNk33MU8hRE6vNfTkrD',
	'biduL1vUTmBXCScf9tNex7p9RYzhC5zTkvNuK1Cq31F',
	'2dNSa3fBPMoxcs46NhtdLeTJuLasDt6VYNG4vopa7mWw',
	'CbBm2THe9kRDUWA3hSe7FeYXSP9cRNqLBVxoHqqkt8d1',
	'CtrQJ5m7JjK69AMzqxRNb5mE1o4bLAfYE1zmeci9kWSW',
	'9iJkX8uRvhYhTi9b6gWznnooAhfSYkCFHTWWLirE4PfP',
	'rAAUE55vA5cs3HVv9yh5UGesZBmhMG7tqpc72tJK9HR',
	'68MBTXQKbSifkETYG6zJFauiWf8rPq2CSfrRaj1ZsLBy',
];

export default function useTopMakerAlertNotification() {
	const currentAuthority = useCurrentAuthority();
	const alertNotify = useAlertNotify();

	useEffect(() => {
		if (
			!currentAuthority ||
			!TOP_MAKER_AUTHORITIES.includes(currentAuthority.toBase58())
		) {
			return;
		}

		alertNotify({
			alertType: 'minor',
			id: 'top-maker-get-in-touch-2',
			disableAlertAutoDismiss: true,
			message: (
				<div className="flex flex-col gap-y-sm typo-body-xs">
					<p>
						Hey Team, we&apos;ve just launched a{' '}
						<Link
							href="https://driftprotocol.notion.site/Drift-Protocol-Market-Maker-Performance-Program-External-314b74b65a988073a389ef49de78b7bd"
							openInNewTab
						>
							MM Program
						</Link>
						.
					</p>

					<p>
						Please contact{' '}
						<Link href="tg://resolve?domain=tracybbd" rightIcon="none">
							@tracybbd
						</Link>{' '}
						for more info and to participate.
					</p>
				</div>
			),
		});
	}, [currentAuthority, alertNotify]);
}
